define(['jquery',
        'moment',
        'core/browser-storage',
        'baremetrics-calendar',
        'jquery.browser'],
    function($, moment, browser_storage, baremetrics_calendar) {
        var backing_component = null;
        var default_preset = 'Last 90 days';

        var daterange_default_options = {
            earliest_date: moment('2013-05-15'),
            latest_date: moment('2033-05-15'),
            preset_label: default_preset,
            sticky_presets: true,
            same_day_range: true,
            presets: [
                {
                    label: 'Last 30 days',
                    start: moment().subtract(30, 'days'),
                    end: moment()
                },
                {
                    label: 'Last 90 days',
                    start: moment().subtract(90, 'days'),
                    end: moment()
                },
                {
                    label: 'This week',
                    start: moment().startOf('week'),
                    end: moment().endOf('week')
                },
                {
                    label: 'Last week',
                    start: moment().subtract(1, 'week').startOf('week'),
                    end: moment().subtract(1, 'week').endOf('week')
                },
                {
                    label: 'This month',
                    start: moment().startOf('month'),
                    end: moment().endOf('month')
                },
                {
                    label: 'Last month',
                    start: moment().subtract(1, 'month').startOf('month'),
                    end: moment().subtract(1, 'month').endOf('month')
                },
                {
                    label: 'This quarter',
                    start: moment().startOf('quarter'),
                    end: moment().endOf('quarter')
                },
                {
                    label: 'Last quarter',
                    start: moment().subtract(1, 'quarter').startOf('quarter'),
                    end: moment().subtract(1, 'quarter').endOf('quarter')
                },
                {
                    label: 'This year',
                    start: moment().startOf('year'),
                    end: moment().endOf('year')
                },
                {
                    label: 'Last year',
                    start: moment().subtract(1, 'year').startOf('year'),
                    end: moment().subtract(1, 'year').endOf('year')
                },
                {
                    label: 'All',
                    start: moment(globals.created_on),
                    end: moment()
                }
            ],
            format: {
                input: 'DD MMM YYYY'
            }
        };

        function getPersistentValue(prefix, name) {
            return browser_storage.getItem(prefix + '-' + name);
        }

        function create(options, onChange) {
            var selector = '#datepicker';
            var combined_options = $.extend(daterange_default_options,
                                            options,
                                            {element: $(selector), callback: onChange});

            // initialize the daterangepicker
            backing_component = new baremetrics_calendar(combined_options);

            document.addEventListener("click",(e)=>{
              let target = e.target;
              let targetId = target.getAttribute("id");
              let count = 0;
              let inside = false;
              while (targetId !== "datepicker" && count<5) {
                if (!target) {
                  break;
                }
                target = target.parentNode;
                if (!target || !target.getAttribute) {
                  break;
                }
                targetId = target.getAttribute("id");
                if (targetId === "datepicker") {
                  inside = true;
                }
              }
              if (!inside) {
                  backing_component.calendarClose('force');
                  if (backing_component.presetIsOpen)
                        backing_component.presetToggle();
              }

            })
            // if ($.browser.mobile) {
            //     // blur on mobile devices to hide soft keyboard
            //     backing_component.element.on('focus', function() {
            //         $(this).blur();
            //     });
            // }
        }

        function reset() {
            console.log("drp reset")
            setPreset(default_preset);
        }

        function set(start, end) {
            backing_component.start_date = start;
            backing_component.end_date = end;
            backing_component.preset_label = null;
            backing_component.calendarSetDates();
        }

        function setPreset(preset_label) {
            var preset = backing_component.settings.presets.find(function(obj) {
              return obj.label === preset_label;
            });
            backing_component.preset_label = preset.label;
            backing_component.start_date = preset.start;
            backing_component.end_date = preset.end;
            backing_component.calendarSetDates();
            backing_component.calendarSaveDates();
        }

        function loadFromBrowserStorage(prefix) {
            var persitent = getPersistentValue(prefix, 'preset');
            if(persitent != null && persitent != 'undefined' && persitent != '' && persitent != 'null') {
                setPreset(getPersistentValue(prefix, 'preset'));
            } else if(getPersistentValue(prefix, 'start_date') && getPersistentValue(prefix, 'end_date')) {
                var restoredStartDate = moment(getPersistentValue(prefix, 'start_date'));
                var restoredEndDate = moment(getPersistentValue(prefix, 'end_date'));
                set(restoredStartDate, restoredEndDate);
            }
        }

        function saveToBrowserStorage(prefix) {
                browser_storage.setItem(prefix + '-preset', backing_component.preset_label);
                browser_storage.setItem(prefix + '-start_date', backing_component.start_date.format());
                browser_storage.setItem(prefix + '-end_date', backing_component.end_date.format());
        }

        return {
            set: set,
            create: create,
            reset: reset,
            loadFromBrowserStorage: loadFromBrowserStorage,
            saveToBrowserStorage: saveToBrowserStorage,
            getStartDate: function() {
                return backing_component.start_date;
            },
            getEndDate: function() {
                return backing_component.end_date;
            },
            getPreset: function() {
                return backing_component.preset_label;
            },
            moment: moment   // convenience export, because daterangepicker users often need direct access to create moment objects as well
        };
    }
);
